var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Server-Side Facts")]),_c('AgGridVue',{staticClass:"ag-theme-balham",staticStyle:{"width":"100%","height":"640px"},attrs:{"rowData":_vm.dataset,"gridOptions":_vm.gridOptions,"floatingFilter":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }